module.exports = __webpack_public_path__ + "img/card-sample.5d421b86.png";